import { JSX } from 'react'

import { IconProps } from '../../icon'

const GoogleClassroom: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 49 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M11.4213 12.9071H37.6016V34.7213H11.4213V12.9071Z'
      fill='#0F9D58'
    />
    <path
      d='M30.3283 24.5464C31.2347 24.5464 31.9643 23.8114 31.9643 22.9105C31.9643 22.0097 31.2292 21.2746 30.3283 21.2746C29.4275 21.2746 28.6924 22.0097 28.6924 22.9105C28.6924 23.8114 29.4275 24.5464 30.3283 24.5464ZM30.3283 25.6352C28.5763 25.6352 26.6917 26.5637 26.6917 27.7133V28.9071H33.9649V27.7133C33.9649 26.5637 32.0803 25.6352 30.3283 25.6352ZM18.6945 24.5464C19.6009 24.5464 20.3304 23.8114 20.3304 22.9105C20.3304 22.0097 19.5953 21.2746 18.6945 21.2746C17.7936 21.2746 17.0586 22.0097 17.0586 22.9105C17.0586 23.8114 17.7936 24.5464 18.6945 24.5464ZM18.6945 25.6352C16.9425 25.6352 15.0579 26.5637 15.0579 27.7133V28.9071H22.3311V27.7133C22.3311 26.5637 20.4465 25.6352 18.6945 25.6352Z'
      fill='#57BB8A'
    />
    <path
      d='M24.5141 23.0874C25.7189 23.0874 26.6972 22.1092 26.6917 20.9043C26.6917 19.6995 25.7134 18.7212 24.5086 18.7268C23.3037 18.7268 22.331 19.705 22.331 20.9098C22.331 22.1147 23.3093 23.0874 24.5141 23.0874ZM24.5141 24.5465C22.0602 24.5465 19.424 25.8508 19.424 27.4535V28.9071H29.6043V27.4535C29.6043 25.8452 26.968 24.5465 24.5141 24.5465Z'
      fill='#F7F7F7'
    />
    <path d='M27.4213 33.2732H33.965V34.7267H27.4213V33.2732Z' fill='#F1F1F1' />
    <path
      d='M38.3311 10H10.6972C9.4924 10 8.51416 10.9782 8.51416 12.1831V35.4563C8.51416 36.6556 9.4924 37.6339 10.6972 37.6339H38.3311C39.5359 37.6339 40.5142 36.6556 40.5142 35.4508V12.1831C40.5086 10.9782 39.5359 10 38.3311 10ZM37.6016 34.7268H11.4212V12.9071H37.6016V34.7268Z'
      fill='#F4B400'
    />
    <path
      opacity='0.2'
      d='M38.3311 10H10.6972C9.4924 10 8.51416 10.9782 8.51416 12.1831V12.3655C8.51416 11.1606 9.4924 10.1824 10.6972 10.1824H38.3311C39.5359 10.1824 40.5142 11.1606 40.5142 12.3655V12.1831C40.5086 10.9782 39.5359 10 38.3311 10Z'
      fill='white'
    />
    <path
      opacity='0.2'
      d='M38.3311 37.4515H10.6972C9.4924 37.4515 8.51416 36.4733 8.51416 35.2684V35.4508C8.51416 36.6557 9.4924 37.6339 10.6972 37.6339H38.3311C39.5359 37.6339 40.5142 36.6557 40.5142 35.4508V35.2684C40.5086 36.4733 39.5359 37.4515 38.3311 37.4515Z'
      fill='#BF360C'
    />
    <path
      d='M33.9539 34.7268H27.4102L30.3172 37.6339H36.8554L33.9539 34.7268Z'
      fill='url(#paint0_linear_159_52)'
    />
    <path
      opacity='0.2'
      d='M11.4213 12.7247H37.6016V12.9071H11.4213V12.7247Z'
      fill='#263238'
    />
    <path
      opacity='0.2'
      d='M11.4213 34.7268H37.6016V34.9092H11.4213V34.7268Z'
      fill='white'
    />
    <path
      d='M38.3311 10H10.6972C9.4924 10 8.51416 10.9782 8.51416 12.1831V35.4563C8.51416 36.6556 9.4924 37.6339 10.6972 37.6339H38.3311C39.5359 37.6339 40.5142 36.6556 40.5142 35.4508V12.1831C40.5086 10.9782 39.5359 10 38.3311 10Z'
      fill='url(#paint1_radial_159_52)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_159_52'
        x1='32.1345'
        y1='34.7654'
        x2='32.1345'
        y2='37.6643'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#BF360C' stopOpacity='0.2' />
        <stop offset='1' stopColor='#BF360C' stopOpacity='0.02' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_159_52'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(9.61643 10.6477) scale(38.2162 38.216)'
      >
        <stop stopColor='white' stopOpacity='0.1' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>
)

export default GoogleClassroom
